import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { ZIndex } from '@styles/z-index';
import { mq } from '@styles/breakpoints';
import { SearchTabsBar } from '@components/search/SearchTabsBar';

const Container: any = styled.div({
  position: 'relative'
});

const SearchWrapper = styled.div(({ theme }: ThemeProps) => ({
  background: theme.custom.colors.group10.lighter,
  width: '100%',
  zIndex: ZIndex.CONTENT,
  boxShadow: `rgba(0, 0, 0, 0.2) 0px 2px 4px`,
  border: `1px solid ${theme.custom.colors.group10.base}`,
  [mq.small]: {
    margin: '-50px auto 0 auto',
    maxWidth: theme.custom.contentSizes.maxContentWidth
  },
  [mq.large]: {
    borderRadius: 10
  }
}));

export const SearchBarContainer = () => {
  return (
    <Container>
      <SearchWrapper>
        <SearchTabsBar isOverlay />
      </SearchWrapper>
    </Container>
  );
};
